import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import { activateToken } from '../api';

export default function Activare() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) { setError('Link invalid: lipsește tokenul de activare.'); return; }
    activateToken(token)
      .then((data) => {
        const cat = data.category || '';
        navigate(`/produse${cat ? `?categorie=${encodeURIComponent(cat)}` : ''}`, { replace: true });
      })
      .catch((e) => {
        const msg = e?.response?.data?.detail;
        setError(typeof msg === 'string' ? msg : 'Link invalid sau expirat.');
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6" data-testid="activare-page">
      {error ? (
        <div className="text-center max-w-[420px]">
          <div className="h-14 w-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
            <AlertTriangle size={28} className="text-red-500" />
          </div>
          <h1 className="font-display font-bold uppercase text-slate-900 text-2xl mb-2">Activare eșuată</h1>
          <p className="text-[14px] text-slate-600 mb-6" data-testid="activare-error">{error}</p>
          <a href="/" className="btn-accent px-6 py-3 text-[13px] uppercase tracking-wide inline-block">Mergi la site</a>
        </div>
      ) : (
        <div className="text-center" data-testid="activare-loading">
          <Loader2 size={34} className="text-[#f5a524] animate-spin mx-auto mb-4" />
          <p className="text-[14px] text-slate-600">Te conectăm...</p>
        </div>
      )}
    </div>
  );
}
